import { render, staticRenderFns } from "./YourForestCard.vue?vue&type=template&id=fd7605dc&scoped=true&"
import script from "./YourForestCard.vue?vue&type=script&lang=js&"
export * from "./YourForestCard.vue?vue&type=script&lang=js&"
import style0 from "./YourForestCard.vue?vue&type=style&index=0&id=fd7605dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd7605dc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VIcon,VRow})
